<template>
    <div
        v-on="$listeners"
        :class="itemClass"
    >
        <TicketSummary
            v-bind="childProps"
            :isWon="isWon"
        />
        <div class="ticket-stack__item--details">
            <div class="ticket-stack__bet-date">
                <i class="icon icon--xs icon-events"/>
                <span>{{ dateReceived | formatDateTime('wddHHMM') }}</span>
            </div>
            <div class="ticket-stack__bet-details">
                <div class="bet-type">
                    {{ $t(type) | upperCase }}
                </div>
                <div class="delimiter"></div>
                <div class="bet-system">
                    {{ isSystem ? $t('system') : $t('simple') | upperCase }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TicketStatus } from '@core/models/tickets/enums';
    import TicketSummary from './TicketSummary';

    export default {
        props: {
            dateReceived: {
                type: Date,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            system: {
                type: Object,
                default: null,
            },
            // child props
            potentialWin: {
                type: Number,
                required: true,
            },
            payoff: {
                type: Number,
                required: true,
            },
            stake: {
                type: Number,
                required: true,
            },
            coefficient: {
                type: Number,
                required: true,
            },
            status: {
                type: String,
                required: true,
            },
            numEventsLeft: {
                type: Number,
                required: true,
            },
            hasOngoingEvents: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        computed: {
            isSystem() {
                return !!this.system;
            },
            itemClass() {
                let status;
                switch (this.status) {
                    case TicketStatus.win:
                        status = 'won';
                        break;
                    case TicketStatus.lost:
                        status = 'lost';
                        break;
                    case TicketStatus.refund:
                        status = 'refund';
                        break;
                    default:
                        status = 'default';
                        break;
                }
                return ['ticket-stack__item', status];
            },
            isWon() {
                return this.status === TicketStatus.win;
            },
            childProps() {
                const {
                    type: _type,
                    system: _system,
                    ...props
                } = this.$props;
                return props;
            },
        },
        components: {
            TicketSummary,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/StackCardItem.vue